var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCards(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 26,
    height: 22,
    viewBox: "0 0 26 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.59263 10.6837C10.9747 9.295 13.2326 9.28125 14.6284 10.6837L16.0516 12.1138C16.3663 12.43 16.9 12.43 17.2147 12.1138L25.3568 3.9325C24.2621 1.60875 21.8947 0 19.1716 0H6.84211C3.06526 0 0 3.08 0 6.875V15.125C0 16.5963 0.465263 17.9575 1.24526 19.0713L9.59263 10.6837ZM6.15789 4.125C7.29368 4.125 8.21053 5.04625 8.21053 6.1875C8.21053 7.32875 7.29368 8.25 6.15789 8.25C5.0221 8.25 4.10526 7.32875 4.10526 6.1875C4.10526 5.04625 5.0221 4.125 6.15789 4.125ZM26 7.16375V15.125C26 18.92 22.9347 22 19.1579 22H6.84211C5.51474 22 4.28316 21.615 3.22947 20.9688L11.5221 12.6362C11.8368 12.32 12.3705 12.32 12.6853 12.6362L14.1084 14.0662C15.4495 15.4137 17.7895 15.4137 19.1305 14.0662L26 7.16375Z",
    fill: "#404040"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCards);
export default __webpack_public_path__ + "static/media/cards.67605415eb73f4b3456db79c4c3b9141.svg";
export { ForwardRef as ReactComponent };